<script setup lang="ts">
import { ref } from 'vue'
import A5Debug from '@/components/debug/A5Debug.vue'
import VinComparison from '@/components/debug/VinComparison.vue'
import DebugReport from '@/components/debug/DebugReport.vue'

// Default tab: Inventory reconcile debug report (/debug/{jazelId})
const tab = ref('a5-vs-a6')
</script>

<template>
  <v-container fluid class="pa-0 pa-md-4 py-12 py-md-4">
    <v-card class="w-100">
      <v-card-title
        class="d-flex justify-space-between align-center text-h5 font-weight-bold sticky-header"
      >
        Debug Dashboard
      </v-card-title>

      <v-tabs v-model="tab" color="primary">
        <v-tab value="a5-vs-a6">A5 vs A6 Comparison</v-tab>
        <v-tab value="vin-comparison">VIN Comparison</v-tab>
        <v-tab value="debug-report">Inventory Debug Report</v-tab>
      </v-tabs>

      <v-divider></v-divider>

      <v-card-text class="pa-4">
        <v-window v-model="tab">
          <v-window-item value="a5-vs-a6">
            <A5Debug />
          </v-window-item>
          <v-window-item value="vin-comparison">
            <VinComparison />
          </v-window-item>
          <v-window-item value="debug-report">
            <DebugReport />
          </v-window-item>
        </v-window>
      </v-card-text>
    </v-card>
  </v-container>
</template>
